<!-- report_post_list_x.vue -->
<template>
  <reportPostList
      ref="inner"
      :report_id="report_id"
      :sns_type="'x'"
      :postValueComponent="reportPostValueX"
      v-bind="$attrs"
      v-on="$listeners"
  />
</template>

<script>
import reportPostList from "./report_post_list.vue";
import reportPostValueX from "./report_post_value_x.vue";

export default {
  name: "reportPostListX",
  props: ["report_id"],
  components: { reportPostList },
  data() {
    return { reportPostValueX };
  },
  methods: {
    reload() {
      this.$refs.inner?.reload?.();
    },
  },
};
</script>
